import {message, ModalProps, Skeleton} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import FormRender, {Schema, useForm} from 'form-render';
import {useMutation, useQuery} from 'react-query';
import {ProModal} from '../../../../../../Components/ProModal';
import {getTenant, saveTenant, TenantType} from '../../../service';

interface Props extends ModalProps {
    id?: string;
    onOk: () => void;
}

const Index = ({id, onOk, ...props}: Props) => {
    const form = useForm();

    const onSave = useMutation({
        mutationFn: saveTenant,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const defaultData = useQuery({
        queryKey: ['getTenant', id],
        queryFn: () => getTenant(id),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    const schema: Schema = {
        type: 'object',
        column: 1,
        displayType: 'row',
        labelCol: 6,
        fieldCol: 15,
        properties: {
            name: {
                title: '全称',
                type: 'string',
                required: true,
            },
            nameShort: {
                title: '简称',
                type: 'string',
                placeholder: '多个用;分割',
                required: true,
            },
            contacts: {
                title: '联系人',
                type: 'string',
            },
            phone: {
                title: '联系电话',
                type: 'string',
            },
            email: {
                title: '邮箱地址',
                type: 'string',
                format: 'email',
            },
            locationDetail: {
                title: '详细地址',
                type: 'string',
                widget: 'textArea',
            },
        },
    };

    return (
        <ProModal {...props} title="私有化" onOk={form.submit}>
            <div className={Style.root}>
                <Skeleton active loading={defaultData?.isFetching}>
                    <FormRender
                        form={form}
                        schema={schema}
                        onFinish={formData =>
                            onSave.mutate({
                                ...formData,
                                id,
                                type: TenantType.Private,
                            })
                        }
                        footer={false}
                    />
                </Skeleton>
            </div>
        </ProModal>
    );
};

export default Index;
